var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVibecoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9706 40.9706C50.3431 31.598 50.3431 16.402 40.9706 7.02944C31.598 -2.34314 16.402 -2.34315 7.02944 7.02944C-2.34315 16.402 -2.34315 31.598 7.02944 40.9706C16.402 50.3431 31.598 50.3431 40.9706 40.9706Z",
    fill: "#FFE27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7634 23.584C42.7634 29.6627 39.9019 35.0712 35.4493 38.5361C32.2417 41.0387 28.1988 42.5282 23.8192 42.5282C13.3578 42.5282 4.87498 34.0454 4.87498 23.584C4.87498 18.1437 7.1648 13.2433 10.8393 9.79107C10.8425 9.78154 10.852 9.77837 10.852 9.77837C14.2375 6.59612 18.8013 4.64294 23.816 4.64294C34.2806 4.64294 42.7634 13.1194 42.7634 23.584Z",
    fill: "#E2A00E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4821 24.6795C41.4821 30.1516 39.1605 35.087 35.4447 38.536C32.2371 41.0386 28.1942 42.5281 23.8146 42.5281C13.3532 42.5281 4.87037 34.0453 4.87037 23.5839C4.87037 18.1435 7.1602 13.2431 10.8347 9.79094C10.8379 9.78141 10.8474 9.77824 10.8474 9.77824C14.0646 7.24387 18.1266 5.73214 22.5411 5.73214C32.9993 5.73214 41.4821 14.215 41.4821 24.6795Z",
    fill: "#FFBD1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8608 17.1554L23.1761 24.2304L27.4915 17.1554H34.9807L23.1761 36.5091L11.3715 17.1554H18.8608Z",
    fill: "#E2A00E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2822 10.7031L25.9875 15.2814L23.2822 19.8596L20.5768 15.2814L23.2822 10.7031Z",
    fill: "#E2A00E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibecoinIcon);
export default __webpack_public_path__ + "static/media/vibecoin-icon.b862ea1dc29bf7cf6e109ae8dab7a65b.svg";
export { ForwardRef as ReactComponent };